import { useTranslation } from "react-i18next";
import i18next from "../i18n";
import React, { useState, useEffect } from "react";
import { MdLanguage, MdOutlineExpandLess } from "react-icons/md";

const LangButton = () => {
  const { t } = useTranslation();

  const languageMap = {
    'zh': '繁體中文',
    'en': 'English',
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = (e) => {
    if (!e.target.closest('.dropdown')) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdown);
  
    return () => {
      document.removeEventListener("click", closeDropdown);
    };
  }, []);

  const onClickDrop = (lang) =>{
    setIsOpen(!isOpen);
    i18next.changeLanguage(lang);
  }

  return (
    <div>
      <div className="dropdown">
        {isOpen && (
          <ul className="dropdown-content">
            {Object.keys(languageMap).map((lang) => (
              <li key={lang} onClick={() => onClickDrop(lang)}>
                {languageMap[lang]}
              </li>
            ))}
          </ul>
        )}
        <button className="drop-btn" onClick={toggleDropdown}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <MdLanguage size={24} /> {languageMap[i18next.language] || i18next.language} <MdOutlineExpandLess size={24} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default LangButton;
